// extracted by mini-css-extract-plugin
module.exports = {"wrap-article":"NewsCard_wrap-article__YOAfG","box-article":"NewsCard_box-article__TkDMP","right-title":"NewsCard_right-title__k405J","right-above":"NewsCard_right-above__bfyfl"};